var _rect, _text, _rect2, _circle, _path, _text2, _rect3, _circle2, _path2, _text3, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobsList = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 570",
  width: 1000,
  height: 570,
  role: "img",
  "aria-label": "Jobs screen",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 570,
  rx: 14,
  fill: "#F6F8FE"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 30,
  y: 75,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 28,
  fontWeight: 700,
  fill: "#172033"
}, "Jobs")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 875,
  y: 48,
  width: 103,
  height: 30,
  rx: 6,
  fill: "#2F6DF6"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 891,
  cy: 63,
  r: 5,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M891 60v6M888 63h6",
  stroke: "#FFFFFF",
  strokeWidth: 1.3
})), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 936,
  y: 67,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fontWeight: 700,
  fill: "#FFFFFF",
  textAnchor: "middle"
}, "Create Job")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 104,
  width: 948,
  height: 33,
  rx: 3,
  fill: "#FFFFFF",
  stroke: "#C8D0DC"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 120.5,
  r: 5,
  fill: "none",
  stroke: "#66728A",
  strokeWidth: 1.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M51 124.5l5 5",
  stroke: "#66728A",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 72,
  y: 125,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 13,
  fill: "#98A1B2"
}, "Search for job")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(30 157)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 310,
  height: 226,
  rx: 6,
  fill: "#FFFFFF",
  stroke: "#E1E7F0"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 32,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  fill: "#172033"
}, "Product Designer"), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 26,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 31,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 36,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 54,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#66728A"
}, "Created on 06/11/2026, 09:19 AM \xB7"), /*#__PURE__*/React.createElement("path", {
  d: "M181 51h6v6h-6zM184 47v10M178 57h12",
  stroke: "#66728A",
  strokeWidth: 1,
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 76,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fontWeight: 700,
  fill: "#445066"
}, "by Dev-Recruiter Assess"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 102,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#4C566A"
}, "- Set design requirements based on information from"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 116,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#4C566A"
}, "internal teams and user research. - Identify new produ..."), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 148,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Communication"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 164,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 151,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 148,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Work Level"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 164,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "Medium"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 151,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 151,
  width: 5,
  height: 14,
  opacity: 0.25
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 151,
  width: 5,
  height: 14,
  opacity: 0.25
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 151,
  width: 5,
  height: 14,
  opacity: 0.25
})), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 195,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Execution"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 211,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 198,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 195,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Critical Thinking"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 211,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "Medium"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 198,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 198,
  width: 5,
  height: 14,
  opacity: 0.25
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 198,
  width: 5,
  height: 14,
  opacity: 0.25
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 198,
  width: 5,
  height: 14,
  opacity: 0.25
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(356 157)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 310,
  height: 226,
  rx: 6,
  fill: "#FFFFFF",
  stroke: "#E1E7F0"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 32,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  fill: "#172033"
}, "Product Manager"), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 26,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 31,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282,
  cy: 36,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 54,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#66728A"
}, "Created on 06/09/2026, 07:32 AM \xB7"), /*#__PURE__*/React.createElement("text", {
  x: 176,
  y: 54,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#445066"
}, "by Guilie Test"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 86,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Communication"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 102,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 89,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 86,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Work Level"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 102,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 89,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 89,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 133,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Execution"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 149,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 136,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 133,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Critical Thinking"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 149,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 136,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 136,
  width: 5,
  height: 14
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(682 157)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 296,
  height: 226,
  rx: 6,
  fill: "#FFFFFF",
  stroke: "#E1E7F0"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 32,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  fill: "#172033"
}, "Lead Developer"), /*#__PURE__*/React.createElement("circle", {
  cx: 270,
  cy: 26,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 270,
  cy: 31,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 270,
  cy: 36,
  r: 1.5,
  fill: "#66728A"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 54,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#66728A"
}, "Created on 04/20/2026, 10:24 AM \xB7"), /*#__PURE__*/React.createElement("path", {
  d: "M181 51h6v6h-6zM184 47v10M178 57h12",
  stroke: "#66728A",
  strokeWidth: 1,
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 76,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fontWeight: 700,
  fill: "#445066"
}, "by Dev-Recruiter Assess"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 108,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Communication"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 124,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "Medium"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 111,
  width: 5,
  height: 14,
  opacity: 0.25
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 111,
  width: 5,
  height: 14,
  opacity: 0.25
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 108,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Work Level"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 124,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 111,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 111,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 155,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Execution"), /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 171,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 74,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 81,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 158,
  width: 5,
  height: 14
})), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 155,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, "Critical Thinking"), /*#__PURE__*/React.createElement("text", {
  x: 160,
  y: 171,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#172033"
}, "High"), /*#__PURE__*/React.createElement("g", {
  fill: "#2F6DF6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 228,
  y: 158,
  width: 5,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 158,
  width: 5,
  height: 14
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobsList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jobs-list.5ca0774f8eb2908f9ba31e448a5c5b64.svg";